import React from 'react';
import _ from 'lodash';
import { Chip, Tooltip } from '@mui/material';

// Logo de la integracion de la que salio el pedido, por `source_system`. Mercado Libre
// no esta: los pedidos del bridge ya pintan su logo junto al tipo de envio, y uno que
// viene por Bsale muestra el de Bsale, que es de donde realmente se sincronizo.
export const SOURCE_LOGOS = {
    bsale:   { src: '/images/icons/bsale.svg', label: 'Bsale' },
    relbase: { src: '/images/icons/relbase-sale-notes-color.svg', label: 'Relbase' },
    shopify: { src: '/images/icons/shopify.svg', label: 'Shopify' },
    // Creado a mano desde el boton Crear de Pedidos (OrdersController#create).
    manual:  { src: '/images/icons/haulers.png', label: 'Haulers', tooltip: 'Creado desde Haulers' },
};


// Nombre del documento de un pedido, para el tooltip del logo. Mismo agrupamiento que
// el filtro, para que lo que dice el tooltip sea lo que despues se filtra.
const INVOICE_METHOD_LABELS = {
    boleta: 'Boleta E.',
    factura: 'Factura',
    invoice: 'Factura',
    factura_exenta: 'Factura exenta',
    nota_venta: 'N. Venta',
    nota_venta_ml: 'N. Venta',
    guia_despacho: 'Guía de despacho',
    'delivery-note': 'Guía de despacho',
    nota_credito: 'Nota de crédito',
    nota_debito: 'Nota de débito',
    traslado: 'Traslado',
    otro: 'Otro',
    manual: 'Manual',
};

// Etiqueta del documento de un pedido. Los tipos propios de la empresa en el ERP (Pedido
// mayorista, Pedido WhatsApp) llegan como 'otro' con su nombre: se muestra ese nombre, que
// es lo que la empresa reconoce, y el filtro los sigue agrupando en "Otro".
export const invoiceMethodLabel = (order) => {
    if (order?.invoice_method === 'otro' && order?.document_type_name) {
        return _.upperFirst(_.toLower(order.document_type_name))
    }
    // Relbase solo sincroniza notas de venta, y la factura o guia se elige recien al
    // pickear: hasta entonces el pedido es su nota de venta. El filtro los agrupa igual.
    if (order?.source_system === 'relbase' && !order?.invoice_method) {
        return INVOICE_METHOD_LABELS.nota_venta
    }
    // El pedido creado a mano es "Manual" hasta que al pickear se le elige un documento.
    if (order?.source_system === 'manual' && !order?.invoice_method) {
        return INVOICE_METHOD_LABELS.manual
    }
    return INVOICE_METHOD_LABELS[order?.invoice_method]
}

// Tamaños: 'medium' es el del listado de Pedidos; 'small' el de las tarjetas compactas
// de Planificación, que van al lado de un código en h5 y del logo de Mercado Libre (16px).
const SIZES = {
    medium: { logo: 22, logoMargin: 8, chipHeight: 22, chipFont: '0.7rem', chipMargin: 1 },
    small:  { logo: 16, logoMargin: 4, chipHeight: 18, chipFont: '0.65rem', chipMargin: 0.5 },
};

// Logo de la integracion de origen y etiqueta del tipo de documento del pedido. Con `only`
// ('logo' o 'label') pinta solo una de las dos: la tabla de Pedidos pone el logo antes del
// numero y la etiqueta despues.
const OrderSourceBadges = ({ order, size = 'medium', only = null }) => {
    const dims = SIZES[size] || SIZES.medium;
    const source = SOURCE_LOGOS[order?.source_system];
    const documentLabel = invoiceMethodLabel(order);

    return (
        <>
            {source && only !== 'label' && (
                <Tooltip
                    arrow
                    title={source.tooltip || [
                        `Sincronizado desde ${source.label}`,
                        documentLabel,
                    ].filter(Boolean).join(' · ')}
                >
                    <img
                        src={source.src}
                        alt={source.label}
                        style={{ width: dims.logo, height: dims.logo, marginLeft: dims.logoMargin, borderRadius: 4, verticalAlign: 'middle' }}
                    />
                </Tooltip>
            )}

            {/* El tipo de documento a la vista, no solo en el tooltip del logo:
                es lo mismo que filtra el selector Documento de Pedidos. */}
            {documentLabel && only !== 'logo' && (
                <Chip
                    label={documentLabel}
                    size="small"
                    variant="outlined"
                    sx={{ ml: dims.chipMargin, height: dims.chipHeight, fontSize: dims.chipFont, verticalAlign: 'middle' }}
                />
            )}
        </>
    );
};

export default OrderSourceBadges;
